import mod from "-!./reset_password.js?vue&type=script&lang=js&"; export default mod; export * from "-!./reset_password.js?vue&type=script&lang=js&"